import workspaceQuery from 'graphql/queries/customer/CustomerAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/common/AuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const CustomerAuditByField = {
  type: 'AuditChange',
  formTitle: 'Customer Audit',
  formUrl: '/Customers/CustomerAudit/Form',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Customers',
  screenReference: 'CUSTOMERS_AUDIT',
  operations: ALLOW_VIEW,
};

export default CustomerAuditByField;
